export default class PolyglotMissingKey extends Error {
    constructor(message) {
        super();
        this.name = 'PolyglotMissingKey';
        this.message = 'key missing: ' + message;
    }
}
